import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import {
  ExclamationCircleIcon,
  PencilSquareIcon,
} from "@heroicons/react/20/solid";
import { Dialog } from "@headlessui/react";
import { useToast } from "../../context/ToastProvider";

function UpdateConfirmation({
  id_crypt,
  apiType,
  fetchClientData,
  inputs,
  setOpenDialogBoxForLead,
  deletedImages,
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const { triggerToast } = useToast();

  const openDialog = (id_crypt) => {
    setCurrentProjectId(id_crypt);
    setIsDialogOpen(true);
  };

  // const handleUpdateForLeadTask = async (e) => {
  //   e.preventDefault();
  //   let endpoint = "";

  //   if (apiType === "customer") {
  //     endpoint = `public/api/admin/customer/update/${currentProjectId}`;
  //   } else if (apiType === "lead") {
  //     endpoint = `public/api/leads/${currentProjectId}`;
  //   }

  //   try {
  //     const response = await axios.put(endpoint, inputs, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //       },
  //     });

  //     // toast.success(response.data.message);

  //     // if (typeof fetchClientData === "function") {

  //       await fetchClientData();
  //       setOpenDialogBoxForLead(false);
  //       // setIsDialogOpen(false);
  //     triggerToast("success", response.data.message, "success");

  //     // }
  //   } catch (error) {
  //     // triggerToast(
  //     //   "error",
  //     //   error.response?.data?.message || "Failed to update item.",
  //     //   "error"
  //     // );
  //     // toast.error(error.response?.data?.message || "Failed to update item.");
  //   }
  // };

  // const closeDialog = () => {
  //   setIsDialogOpen(false);
  //   setCurrentProjectId(null);
  // };

  const handleUpdateForLeadTask = async (e) => {
    e.preventDefault();
    let endpoint = "";

    if (apiType === "customer") {
      endpoint = `public/api/admin/customer/update/${currentProjectId}`;
    } else if (apiType === "lead") {
      endpoint = `public/api/leads/${currentProjectId}`;
    }

    const formData = new FormData();
    formData.append("customer_name", inputs.customer_name || "");
    formData.append("contact_no", inputs.contact_no || "");
    formData.append("contact_person", inputs.contact_person || "");
    formData.append("contact_person_no", inputs.contact_person_no || "");
    formData.append(
      "advertisement_mode_id",
      inputs.advertisement_mode_id || ""
    );
    formData.append("sales_service", inputs.sales_service || "");
    formData.append("lead_status", inputs.lead_status || "");
    formData.append("followup_date", inputs.followup_date || "");
    formData.append("country", inputs.country || "");
    formData.append("state", inputs.state || "");
    formData.append("city", inputs.city || "");
    formData.append("address", inputs.address || "");
    formData.append("pincode", inputs.pincode || "");
    formData.append("loss_reason", inputs.loss_reason || "");

    (inputs.type_of_work || []).forEach((work, index) => {
      formData.append(`type_of_work[${index}]`, work);
    });

    formData.append("worker_tally_id", inputs.worker_tally_id || "");
    formData.append("worker_name", inputs.worker_name || "");
    formData.append("salesman_tally_id", inputs.salesman_tally_id || "");
    formData.append("salesman_name", inputs.salesman_name || "");
    formData.append("project_manager", inputs.project_manager || "");
    formData.append("comments", inputs.comments || "");
    formData.append("location", inputs.location || "");
    

    // ✅ new uploads
    (inputs.images || []).forEach((file) => {
      formData.append("images[]", file);
    });

    // ✅ deleted old images
    (deletedImages || []).forEach((id) => {
      formData.append("deleted_images[]", id);
    });
    formData.append("_method", "PUT");
    try {
    
      const response = await axios.post(endpoint, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      });

      // Refresh data first
      if (typeof fetchClientData === "function") {
        await fetchClientData();
      }

      // Show toast
      triggerToast("success", response.data.message, "success");

      // Close dialog after everything is done
      setOpenDialogBoxForLead(false);
    } catch (error) {
      triggerToast(
        "error",
        error.response?.data?.message || "Failed to update item.",
        "error"
      );
    }
  };

  return (
    <div>
      {/* Update Button */}
      <div className="relative inline-block">
        <button
          type="button"
          className="flex justify-end py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          onClick={() => openDialog(id_crypt)}
        >
          {/* <PencilSquareIcon className="h-5 w-5 text-white" /> */}
          Update
          <Tooltip
            anchorSelect=".my-anchor-update"
            place="top"
            className="text-xs"
            style={{ fontSize: "12px", padding: "0.3rem" }}
          >
            Update
          </Tooltip>
        </button>
      </div>

      {/* {isDialogOpen && (
  <div className="fixed inset-0 w-full h-full flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
    <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] sm:w-[80%] md:w-[60%] lg:w-[50%] max-w-[600px] grid gap-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 items-center">
        <div className="flex flex-col sm:flex-row items-center sm:space-x-4">
          <span className="flex items-center justify-center p-2 rounded-full bg-blue-100">
            <ExclamationCircleIcon className="h-6 w-6 text-blue-600" />
          </span>
          <div className="text-center sm:text-left mt-3 sm:mt-0">
            <h2 className="text-lg font-bold text-gray-800">
              Update Confirmation
            </h2>
            <p className="text-gray-600">
              Are you sure you want to update this item?
            </p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:flex sm:justify-end">
        <button
          className="w-full sm:w-auto px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={(e) => handleUpdateForLeadTask(e)}
          className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Update
        </button>
      </div>
    </div>
  </div>
)} */}

      <Dialog open={isDialogOpen} onClose={() => {}} className="relative z-50">
        {/* Background Overlay */}
        <div
          className="fixed inset-0 bg-gray-800 bg-opacity-75"
          aria-hidden="true"
        />

        {/* Dialog Content */}
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="bg-white rounded-lg shadow-lg p-6 w-[90%] sm:w-[80%] md:w-[60%] lg:w-[50%] max-w-[600px] grid gap-6">
            <Dialog.Title className="text-lg font-bold text-gray-800">
              Update Confirmation
            </Dialog.Title>

            <div className="grid grid-cols-1 sm:grid-cols-2 items-center">
              <div className="flex flex-col sm:flex-row items-center sm:space-x-4">
                <span className="flex items-center justify-center p-2 rounded-full bg-blue-100">
                  <ExclamationCircleIcon className="h-6 w-6 text-blue-600" />
                </span>
                <div className="text-center sm:text-left mt-3 sm:mt-0">
                  <p className="text-gray-600">
                    Are you sure you want to update this item?
                  </p>
                </div>
              </div>
            </div>

            {/* Button Controls */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:flex sm:justify-end">
              <button
                onClick={() => setIsDialogOpen(false)}
                className="w-full sm:w-auto px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={(e) => handleUpdateForLeadTask(e)}
                className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Update
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </div>
  );
}

export default UpdateConfirmation;
